var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755329916737,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8646,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M345.6 900.608h113.152c14.848 0 27.648-12.288 27.648-27.648v-244.736l-76.8-41.984-91.648 54.272v232.448c0 15.36 12.288 27.648 27.648 27.648zM15.36 632.32l370.688-219.136 21.504-12.8 22.016 12.288 111.104 60.928 297.472-254.464-41.984-48.128 103.936-20.48 103.936-20.48-34.304 100.352-34.304 100.352-39.424-45.056-321.024 274.944-23.04 19.968-26.624-14.848L409.088 501.76l-349.184 206.336L15.36 632.32z m93.696 268.288h113.152c14.848 0 27.648-12.288 27.648-27.648V680.96l-168.448 99.328v92.672c0 15.36 12.288 27.648 27.648 27.648z m473.088 0h113.152c14.848 0 27.648-12.288 27.648-27.648v-343.552c0-1.536 0-3.072-0.512-4.096l-165.888 141.824-2.048-1.024v207.36c0 14.848 12.288 27.136 27.648 27.136z m236.544 0H931.84c14.848 0 27.648-12.288 27.648-27.648v-414.72l-68.096-77.824-100.352 86.016v406.528c0 15.36 12.288 27.648 27.648 27.648z",
    fill: "#231815",
    "p-id": 8647
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.759055b1.svg";
export { ForwardRef as ReactComponent };